const React = require('react');
const Tooltip = require('../../../../../Tooltip/A');
const {DisplayStatusTrx} = require("../../../../../StatusDisplay");
const {PAYMENT_METHODS} = require('../../../../../../../constants/paymentMethods/');
const formatNumFiat = require('../../../../../../../utils/formatNumFiat');

const {
  DisplayAmountAdmin,
  DisplayIdAdmin,
  DisplayDateDetailedAdmin,
  DisplayDataAdmin,
  DisplayHashAdmin
} = require('../../../../../DisplayData/');

const SECONDARY_DATA = [
  {
    title: 'Internal Transaction ID',
    dataHandler: ({id}) => (
      <DisplayIdAdmin>{id}</DisplayIdAdmin>
    ),
  },
  {
    title: 'Retailer Order ID',
    dataHandler: ({client_quote_id}) => (
      <DisplayIdAdmin>{client_quote_id}</DisplayIdAdmin>
    ),
  },
  {
    title: 'Fiat',
    dataHandler: ({source_amount, source_asset}) => (
      <DisplayAmountAdmin amount={source_amount} symbol={source_asset} type="fiat" />
    )
  },
  {
    title: 'Crypto',
    dataHandler: ({target_amount, target_asset}) => (
      <DisplayAmountAdmin amount={target_amount} symbol={target_asset} type="coin" />
    )
  },
  {
    title: 'Transaction Date and Time',
    dataHandler: ({created_at}) => <DisplayDateDetailedAdmin date={created_at} />
  },
  {
    title: 'Exchange Rate',
    dataHandler: ({target_amount, target_asset, source_amount, source_asset}) => (
      `1 ${target_asset} = ${formatNumFiat(source_amount / target_amount)} ${source_asset}`
    )
  },
  {
    title: 'Destination Address',
    dataHandler: ({destination_address}) => (
      <DisplayDataAdmin>{destination_address}</DisplayDataAdmin>
    ),
  },
  {
    title: 'Status',
    dataHandler: ({lifeflow: status}) => status
      ? (
        <DisplayStatusTrx status={status} />
      ) : '-',
  },
  {
    title: 'Rejection Reason',
    displayCheck: ({reject_reason}) => !!(reject_reason || {}).reject_message,
    dataHandler: ({reject_reason}) => {
      const reason = reject_reason || {};
      return (
        <div className="fw7 cFF481F">
          <DisplayDataAdmin>
            {reason.reject_message}{reason.reject_code ? ` (${reason.reject_code})` : ''}
          </DisplayDataAdmin>
        </div>
      )
    }
  },
  {
    title: 'Payment Method',
    dataHandler: ({payment_method}) => {
      const type = PAYMENT_METHODS[payment_method] || {};
      return type.name || payment_method;
    }
  },
  {
    title: 'Transaction Hash',
    dataHandler: ({hash}) => hash
      ? (
        <Tooltip>
          {hash}
        </Tooltip>
      ) : '-',
  },
  {
    title: 'Withdrawal Hash',
    dataHandler: ({withdrawal_hash}) => (
      <DisplayHashAdmin>
        {withdrawal_hash}
      </DisplayHashAdmin>
    ),
  },
];

module.exports = SECONDARY_DATA;
